/* eslint-disable no-unused-vars */
import { globalStore } from '../store/store'

export default {
	globalStore,
	install(Vue, options) {
		Vue.prototype.$userStore = globalStore
	}
}
